import {FilterValueApiDto} from "../../api/model/rest";

export default class CollectionFilterModel {
	constructor(public readonly radioButtonId: CollectionFilterType) {}

	getDisplayValue() {
		return `${CollectionFilterTypeName[this.radioButtonId]}`
	}

	toQueryJson(): FilterValueApiDto[] {
		return null
	}
}

export enum CollectionFilterType {
	Empty = "IS_EMPTY",
	All = "IS_NOT_EMPTY"
}

export const CollectionFilterTypeName = {
	[CollectionFilterType.Empty]: "Not set",
	[CollectionFilterType.All]: "All"
};